import { render, staticRenderFns } from "./distributionWlserviceEdit.vue?vue&type=template&id=6e80e860&scoped=true&"
import script from "./distributionWlserviceEdit.vue?vue&type=script&lang=js&"
export * from "./distributionWlserviceEdit.vue?vue&type=script&lang=js&"
import style0 from "./distributionWlserviceEdit.vue?vue&type=style&index=0&id=6e80e860&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e80e860",
  null
  
)

export default component.exports